import { Dialog } from '@material-ui/core';
import { RedInfoIcon } from 'assets/icons';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useNewVerificationPanelFlag } from 'shared/featureFlags';
import { hideVerificationModal } from '../../../features/login/store/login.action';
import { APP_URL, SectionNavigation } from '../../constants/common';
import useSectionNavigation from '../../hooks/useSectionNavigation';
import Button from '../form/button';
import DialogCard from './dialogCard';

type InactiveUserDialogProps = {
	open: boolean;
	onClose?: () => void;
	mode?: 'DEPOSIT' | 'LOGIN' | 'BASKET';
};
const InactiveUserDialog = ({ open, onClose, mode }: InactiveUserDialogProps) => {
	const history = useHistory();
	const newVerificationPanelFlag = useNewVerificationPanelFlag();
	const dispatch = useDispatch();
	const { goToFirstNavigationView } = useSectionNavigation();

	const verificationStart = () => {
		dispatch(hideVerificationModal());
		onClose && onClose();

		newVerificationPanelFlag?.value
			? history.push(APP_URL.verification, window.location.pathname)
			: goToFirstNavigationView(SectionNavigation.ACCOUNT_VERIFICATION_METHOD);
	};

	const hideModal = () => {
		onClose && onClose();
		dispatch(hideVerificationModal());
	};

	const getTexts = () => {
		switch (mode) {
			case 'LOGIN': {
				return { title: 'Jesteś niezweryfikowany!', subTitle: 'Zweryfikuj się w 5 minut, a znów będziesz mógł wygrywać!' };
			}
			case 'BASKET': {
				return { title: 'Zweryfikuj się, by zagrać!', subTitle: 'Nie będziesz mógł dalej grać, dopóki nie zweryfikujesz swojego konta.' };
			}
			case 'DEPOSIT': {
				return {
					title: 'Zweryfikuj się, by wpłacić!',
					subTitle: 'Nie będziesz mógł wpłacić pieniędzy na grę, dopóki nie zweryfikujesz swojego konta.',
				};
			}
			default:
				return { title: 'Jesteś niezweryfikowany!', subTitle: 'Zweryfikuj się w 5 minut, a znów będziesz mógł wygrywać!' };
		}
	};

	return (
		<Dialog
			maxWidth="xs"
			fullWidth
			onClose={() => dispatch(hideVerificationModal())}
			className={`custom-dialog bg--transparent custom--box-shadow text--center dialog-wrapper`}
			aria-labelledby="customized-dialog"
			open={open}
		>
			<DialogCard
				title={getTexts().title}
				titleClass={'inactive-user-dialog-title'}
				subTitleClass={'inactive-user-dialog-subtitle'}
				subTitle={getTexts().subTitle}
				className="warning--card inactive-user-dialog "
				icon={RedInfoIcon}
				cardBottomText="Przejdź do weryfikacji"
				cardBottomCustom={
					<div className="inactive-user-dialog-buttons">
						<Button className={'inactive-user-dialog-title-button'} onClick={verificationStart}>
							Weryfikuję się!
						</Button>
						<Button className={'inactive-user-dialog-subtitle-button'} onClick={hideModal}>
							Anuluj
						</Button>
					</div>
				}
			/>
		</Dialog>
	);
};

export default InactiveUserDialog;
